// const ajax=require('./ajax');
// import {ajax} from './ajax';
import ajax from './ajax';
function getQueryString(name, flag) {
	let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	let r = window.location.search.substr(1).match(reg);
	// console.log('r', r);
	if (r != null) {
		if (flag) {
			return r[2];
		}
		return unescape(r[2]);
	}
	return null;
}
class RestApi {
	//用户数据示例
	userId = getQueryString('phone');
	avatar = decodeURIComponent(getQueryString('avatar'));
	user = {
		id: this.userId,
		name: '减重管家',
		phone: this.userId,
		avatar: this.avatar
	};
	users = [ this.user ];
	//群数据示例
	groups = [];
	// 订单
	orders = [
		{
			id: '252364104325',
			url: '/static/images/goods1-1.jpg',
			name: '青桔柠檬气泡美式',
			price: '￥23',
			count: 1
		},
		{
			id: '251662058022',
			url: '/static/images/goods1-2.jpg',
			name: '咸柠七',
			price: '￥8',
			count: 2
		},
		{
			id: '250676186141',
			url: '/static/images/goods1-3.jpg',
			name: '黑糖波波鲜奶茶',
			price: '￥12',
			count: 1
		}
	];

	getUser = () => {
		ajax.Get({
			url: `/api/user/get/${this.user.id}`
		});
	};
	getGroups(patientType) {
		this.getUser();
		return ajax.Post({
			url: '/api/loss/im/getDietGroupByPatientId',
			data: {
				phone: this.user.id,
				searchType: 2,
				patientType
			}
		});
	}
	findUsers() {
		return this.users;
	}

	findFriends(user) {
		return this.users.filter((v) => v.id !== user.id);
	}

	findGroups() {
		return this.groups;
	}

	findUser() {
		return this.users[0];
	}

	getOrderList() {
		return this.orders;
	}

	findGroupById(groupId) {
		return this.groups.find((group) => group.id === groupId);
	}

	findUserById(userId) {
		return this.users.find((user) => user.id === userId);
	}

	// findGroupMembers(groupId) {
	// 	let members = [];
	// 	let group = this.groups.find((v) => v.id === groupId);
	// 	this.users.map((user) => {
	// 		let userId = group.userList.find((id) => {
	// 			return id === user.id;
	// 		});
	// 		members.push(user);
	// 	});
	// 	return members;
	// }

	findGroupMemberAvatars(groupId) {
		let avatars = [];
		let group = this.groups.find((v) => v.id === groupId);
		this.users.map((user) => {
			group.userList.forEach((userId) => {
				if (user.id === userId) {
					avatars.push(user.avatar);
				}
			});
		});
		return avatars;
	}
}

export default new RestApi();
export { getQueryString };
